/*
 * Build-time switches, read from REACT_APP_* variables (frontend/.env, or the shell that runs the
 * dev server or the build). Each is off unless set to "true". Documented in .env.example.
 */

const isOn = (value) => String(value).toLowerCase() === 'true';

/**
 * Shipment Timeline (Stock Management, /shipment-timeline): the menu entry and the page route.
 * Backend twin: SHIPMENT_TIMELINE_ENABLED, without which its API answers 404.
 */
export const shipmentTimelineEnabled = () => isOn(process.env.REACT_APP_SHIPMENT_TIMELINE_ENABLED);

/**
 * Novelty Pipeline (Marketing, /arrival-pipeline/novelties): the menu entry, the page route and the
 * /marketing/arrival-pipeline redirect. Backend twin: NOVELTY_PIPELINE_ENABLED, without which its
 * API answers 404. The Arrival Pipeline (All Products) is not switched.
 */
export const noveltyPipelineEnabled = () => isOn(process.env.REACT_APP_NOVELTY_PIPELINE_ENABLED);
